import { Module } from "./Module";
import { UserPermissionType } from "./UserPermissionType";

/**
 * Nutzer Berechtigungsinfos
 */
export default interface UserPermissionTypeInfoJson {
    /**
     * Rechte-Typ zu dem die Info gehört.
     */
    userPermissionType: UserPermissionType;

    /**
     * Übergeordnetes/zugehöriges Module, das in Verbindung mit der Permission steht.
     */
    parentModule: Module;

    /**
     * Die Option nur eigene Daten kann ausgewählt werden.
     */
    hasLimitToOwnDataOption: boolean;

    /**
     * Beschreibung der Permission
     */
    permissionDsc?: string;

    /**
     * Beschreibung der individuellen Rolle
     */
    permissionRankDsc?: string;

    /**
     * Beschreibung zur Beschränkung auf die eigenen Daten
     */
    limitToOwnDataDsc?: string;
}

export const UserPermissionTypeInfos: UserPermissionTypeInfoJson[] = [
    {
        "userPermissionType": UserPermissionType.moduleEvents,
        "parentModule": Module.Events,
        "hasLimitToOwnDataOption": false,
    },
    {
        "userPermissionType": UserPermissionType.moduleBirthdays,
        "parentModule": Module.Birthdays,
        "hasLimitToOwnDataOption": false,
    },
    {
        "userPermissionType": UserPermissionType.moduleGroups,
        "parentModule": Module.Groups,
        "hasLimitToOwnDataOption": false,
    },
    {
        "userPermissionType": UserPermissionType.moduleHolidays,
        "parentModule": Module.Holidays,
        "hasLimitToOwnDataOption": false,
    },
    {
        "userPermissionType": UserPermissionType.moduleMailings,
        "parentModule": Module.Mailings,
        "hasLimitToOwnDataOption": false,
    },
    {
        "userPermissionType": UserPermissionType.moduleMembers,
        "parentModule": Module.Members,
        "hasLimitToOwnDataOption": false,
    },
    {
        "userPermissionType": UserPermissionType.modulePayments,
        "parentModule": Module.Payments,
        "hasLimitToOwnDataOption": false,
    },
    {
        "userPermissionType": UserPermissionType.moduleRental,
        "parentModule": Module.Rental,
        "hasLimitToOwnDataOption": false,
    },
    {
        "userPermissionType": UserPermissionType.moduleStatistics,
        "parentModule": Module.Statistics,
        "hasLimitToOwnDataOption": false,
    },
    {
        "userPermissionType": UserPermissionType.moduleWorkshops,
        "parentModule": Module.Workshops,
        "hasLimitToOwnDataOption": false,
    },
    {
        "userPermissionType": UserPermissionType.moduleClients,
        "parentModule": Module.Clients,
        "hasLimitToOwnDataOption": false,
    },
    {
        "userPermissionType": UserPermissionType.moduleAccounts,
        "parentModule": Module.Accounts,
        "hasLimitToOwnDataOption": false,
    },
]